import pos from './pos'

export let exportMenu = [
	...pos,
]